import { render, staticRenderFns } from "./PreviousOrder.vue?vue&type=template&id=1b57ab3a&"
import script from "./PreviousOrder.vue?vue&type=script&lang=js&"
export * from "./PreviousOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardText,VContainer,VList,VTabItem})
